// extracted by mini-css-extract-plugin
export var columnItem = "_g6-3";
export var columnItemDraggable = "_g6-5";
export var dragHandle = "_g6-0";
export var dragHandleHovered = "_g6-1";
export var dropdown = "_g6-6";
export var dropdownContent = "_g6-8";
export var dropdownInner = "_g6-7";
export var filterDropdownHeader = "_g6-9";
export var icon = "_g6-2";
export var moveToTopButton = "_g6-4";
export var sectionDivider = "_g6-a";